import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
export const StyleConversationListWrapper = styled.div`
  overflow: auto;
  height: 100%;
`
export const StyleItem = styled.div<any>`
  padding: 20px 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  background: ${(props: any) =>
    props.theme.colors[!!props?.isActive ? 'primary100' : 'white']};
`

export const StyleRow = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  width: 100%;
`

export const StyleNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyleColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  width: 100%;
`

export const StyleName = styled.h5`
  font-size: 14px;
  font-weight: 400;
`

export const StyleMessage = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.placeholder};
`

export const StyleTime = styled.span`
  font-size: 10px;
  color: ${(props: any) => props.theme.colors.placeholder};
  white-space: nowrap;
`
